import React, { useState } from 'react';
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  useParams,
} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Inventory from './inventory';
import ProductDetail from './inventory/ProductDetail';
import Product from './inventory/Product';
import ProductEdit from './inventory/ProductEdit';
// import CouponManagement from './coupons/CouponManagement';
// import CouponCreate from './coupons/CouponCreate';
// import CouponEdit from './coupons/CouponEdit';
import { ShoppingCartIcon, TicketIcon } from '@heroicons/react/24/outline';

const Store = () => {
  const { t } = useTranslation('store');
  const navigate = useNavigate();
  const location = useLocation();
  const { agentId } = useParams();
  const [showStoreInvitation, setShowStoreInvitation] = useState(true);

  // Determine active tab based on current path
  const currentPath = location.pathname;
  const isProductsPath =
    currentPath.includes('/store') && !currentPath.includes('/coupons');
  const isCouponsPath = currentPath.includes('/coupons');

  const handleTabChange = (tab: 'products' | 'coupons') => {
    if (tab === 'products') {
      navigate(`/agent/${agentId}/store`);
    } else {
      navigate(`/agent/${agentId}/store/coupons`);
    }
  };

  const handleInvitationStateChange = (show: boolean) => {
    setShowStoreInvitation(show);
  };

  return (
    <div className="mx-auto h-fit w-full max-w-[1200px] px-0 pt-20 md:px-8">
      {/* Tab Navigation - only show when not showing store invitation */}
      {!showStoreInvitation && (
        <div className="tabs tabs-boxed mb-6 w-fit">
          <button
            className={`tab gap-2 ${isProductsPath ? 'tab-active' : ''}`}
            onClick={() => handleTabChange('products')}
          >
            <ShoppingCartIcon className="h-5 w-5" />
            {t('tabs.products')}
          </button>
          {/* TODO: Uncomment when Cupones feature is ready */}
          {/* <button
            className={`tab gap-2 ${isCouponsPath ? 'tab-active' : ''}`}
            onClick={() => handleTabChange('coupons')}
          >
            <TicketIcon className="h-5 w-5" />
            {t('tabs.coupons')}
          </button> */}
        </div>
      )}

      {/* Routes */}
      <Routes>
        {/* Product Routes */}
        <Route
          path=""
          element={
            <Inventory
              showStoreInvitation={showStoreInvitation}
              onInvitationStateChange={handleInvitationStateChange}
            />
          }
        />
        <Route path="/add" element={<Product />} />
        <Route path="/:id" element={<ProductDetail />} />
        <Route path="/edit/:id" element={<ProductEdit />} />

        {/* TODO: Uncomment when Cupones feature is ready */}
        {/* Coupon Routes */}
        {/* <Route path="/coupons" element={<CouponManagement />} />
        <Route path="/coupons/create" element={<CouponCreate />} />
        <Route path="/coupons/edit/:id" element={<CouponEdit />} /> */}
      </Routes>
    </div>
  );
};

export default Store;
